import { useContext } from 'react';

import { ConfigurationContext } from '../components/Configuration';

/**
 * @example const configuration = useConfiguration();
 * @returns configuration:: The configuration context object including all of the properties that can be set on the Configuration component.
 */
const useConfiguration = () => useContext(ConfigurationContext);

export default useConfiguration;
